import { Box, LinearProgress } from "@mui/material";
import COLORS from "../colors/colors";

export default function LoadingFallback() {
  return (
    <Box width={1}>
      <LinearProgress
        sx={{
          backgroundColor: COLORS.ACCENT_COLOR, // Track color
          "& .MuiLinearProgress-bar": {
            backgroundColor: COLORS.SECONDARY_COLOR, // Bar color
          },
        }}
      />
    </Box>
  );
}
